import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { AuthenticationService } from '../security/authentication.service';
import { Roles } from '@scenario/enums/roles.enum';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';

@Injectable({
    providedIn: 'root',
})
export class ScenarioAuthGuard implements CanActivate {
    constructor(
        private readonly authenticationService: AuthenticationService,
        private readonly router: Router
    ) {}

    canActivate(): Observable<boolean> {
        return this.authenticationService.rolesLoaded$.pipe(
            take(1),
            map(() => {
                const connectedUser = this.authenticationService.connectedUser.getValue();
                if (connectedUser?.roles?.includes(Roles.ADMIN) || connectedUser?.roles?.includes(Roles.USER)) {
                    return true;
                }

                this.router.navigateByUrl('/info');
                return false;
            }),
        );
    }
}
